
import React from 'react';
import { Category, Assessment } from '@/types/assessment';
import { QuestionsList } from './QuestionsList';

interface QuestionsTabProps {
  categories: Category[];
  setCategories: React.Dispatch<React.SetStateAction<Category[]>>;
  isMaturityModel?: boolean;
  assessment?: Assessment | null;
  onContentChange?: () => void;
}

export function QuestionsTab({ 
  categories, 
  setCategories, 
  isMaturityModel = false, 
  assessment,
  onContentChange 
}: QuestionsTabProps) {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold">Assessment Questions</h2>
        <p className="text-sm text-muted-foreground">
          Create and organize questions for each category
        </p>
      </div>
      
      <QuestionsList
        categories={categories}
        setCategories={setCategories}
        isMaturityModel={isMaturityModel}
        assessment={assessment}
        onContentChange={onContentChange}
      />
    </div>
  );
}
